module.exports = __webpack_public_path__ + "static/media/union-1.6bc9c953.jpg";